import { useCallback, useState } from "react";
import { salesService } from "../../api_client";
import { showErrorToast, showSuccessToast } from "../../../utils/toasts";

export function useMarkSaleReceived() {
    const [ isLoading, setIsLoading ] = useState(false);

    const markSaleReceived = useCallback(
        async (id: number): Promise<boolean> => {
            setIsLoading(true);
            try {
                await salesService.markReceived(id);
                showSuccessToast("Sale marked as received successfully!");
                return true;
            } catch (error) {
                console.error("Failed to mark sale as received:", error);
                showErrorToast("Failed to mark sale as received. Please try again.");
                return false;
            } finally {
                setIsLoading(false);
            }
        },
        []
    );

    return { markSaleReceived, isLoading };
}

